import { useTranslation } from "react-i18next";
import { Notification } from "@components/Notification/Notification";
import { useGetBillDetailMeterRules } from "@services/bills/queries";
import type {
  IBillDetail,
  IOverviewJointBillService,
} from "@services/overview/types";
import { isNullOrUndefined } from "@utils/common";

interface IBillDetailMeterRuleProps {
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"];
  billDetailId: IBillDetail["billDetailId"];
  quantity: IBillDetail["quantity"];
}

export const BillDetailMeterRule: React.FC<IBillDetailMeterRuleProps> = ({
  jointBillServiceId,
  billDetailId,
  quantity,
}) => {
  const { t } = useTranslation();

  const { data: billDetailMeterRules } = useGetBillDetailMeterRules(
    jointBillServiceId,
    billDetailId,
  );

  if (
    !billDetailMeterRules?.rules.some(
      (rule) =>
        (!isNullOrUndefined(rule.lowerBound) && quantity <= rule.lowerBound) ||
        (!isNullOrUndefined(rule.upperBound) && quantity >= rule.upperBound),
    )
  ) {
    return null;
  }

  return (
    <Notification color="purple" description={t("billDetail.rules.default")} />
  );
};
